import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import signUpService from '../../components/Services/signUp.service';
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { toastProperties } from '../../commons/Toast/Toaster';

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleClickPassword = () => setShowPassword((show) => !show);
  const handleClickConfirmPassword = () => setShowConfirmPassword((show) => !show);

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  const validationSchema = Yup.object().shape({
    newPassword: Yup.string()
      .required("New Password is required")
      .min(8, "New Password must be at least 8 characters long")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
    "Password size must be 8-20 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      ),

    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref('newPassword'), null], "Password must match New Password"),
  });
  const navigate = useNavigate()

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // Get the value of the "key" parameter
  const keyParam = queryParams.get('key');

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          let reqBody = {
            "token": keyParam && keyParam,
            "password": values.newPassword,
            "confirmPassword": values.confirmPassword,
          }
          signUpService.forgotPasswordReset(reqBody).then((response) => {
            if (response?.data?.code === 200) {
              toast.success(response?.data?.message, toastProperties);
              navigate("/")
            }
          })
        }}
      >
        {({ values, setFieldValue, setFieldTouched, setValues }) => {
          return <Form>
            <div className='login-box-vh-center'>
              <div className='login-box'>
                <div className="p-4" >
                  <div className="fw-bold">Enter a New Password Below to Change Your Password</div>
                  <ErrorMessage name='currentPassword' className='text-danger' component='div' />
                  <div className="mt-3 position-relative">
                    <label className="fw-medium">New Password:</label>
                    <Field type={showPassword ? 'text' : 'password'} className=" custom-input" name="newPassword"
                    />
                    <IconButton className="eye_icon" onClick={handleClickPassword}>
                      {showPassword ? <Visibility /> : <VisibilityOff /> }
                    </IconButton>
                  </div>
                  <ErrorMessage name='newPassword' className='text-danger' component='div' />
                  <div className="mt-3 position-relative">
                    <label className=" fw-medium">Confirm Password:</label>
                    <Field type={showConfirmPassword ? 'text' : 'password'} className=" custom-input" name="confirmPassword"

                    />
                    <IconButton className="eye_icon" onClick={handleClickConfirmPassword}>
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                  <ErrorMessage name='confirmPassword' className='text-danger' component='div' />
                  <button type="submit" className="btn btn-signup btn-primary py-3 mt-3">Reset Password</button>
                </div>
              </div>
            </div>
          </Form>
        }}
      </Formik>
    </>
  );
}

export default ResetPassword;
